/**
 * Helper functions for debugging authentication issues
 */

// Safely stringify any object for logging
export function safeStringify(obj: any): string {
  try {
    return JSON.stringify(
      obj,
      (key, value) => {
        // Avoid circular references and sensitive data
        if (key === 'apiKey' || key === 'accessToken' || key === 'refreshToken') {
          return '[REDACTED]';
        }
        // Handle functions
        if (typeof value === 'function') {
          return '[Function]';
        }
        return value;
      },
      2
    );
  } catch (err) {
    return `[Object could not be stringified: ${err}]`;
  }
}

// Log authentication state safely
export function logAuthState(user: any): void {
  if (!user) {
    console.warn('Auth Debug: No user object');
    return;
  }
  
  // Log important non-sensitive user properties
  console.log('Auth Debug: User state', {
    uid: user.uid || 'MISSING',
    isAnonymous: user.isAnonymous,
    emailVerified: user.emailVerified,
    providerData: user.providerData?.length || 0,
    metadata: {
      creationTime: user.metadata?.creationTime,
      lastSignInTime: user.metadata?.lastSignInTime,
    }
  });
  
  // Check for common issues
  if (!user.uid) {
    console.error('Auth Debug: User missing UID!');
  }
  
  if (user.stsTokenManager) {
    const expirationTime = user.stsTokenManager.expirationTime;
    const now = Date.now();
    const timeRemaining = expirationTime - now;
    
    console.log(`Auth Debug: Token expires in ${Math.floor(timeRemaining / 1000 / 60)} minutes`);
    
    if (timeRemaining < 5 * 60 * 1000) { // less than 5 minutes
      console.warn('Auth Debug: Token expiring soon!');
    }
    
    if (timeRemaining <= 0) {
      console.error('Auth Debug: Token EXPIRED!');
    }
  } else {
    console.warn('Auth Debug: No token manager found');
  }
}
